import { gql } from '@apollo/client';

export default gql`
  mutation addCustomerPassengers($bookingReference: String!, $passengers: [InputPassenger]!, $customer: CustomerInput!) {
    updatePassengers(bookingReference: $bookingReference, passengers: $passengers) {
      reference
      passengers {
        id
        firstName
        lastName
      }
    }

    addCustomer(bookingReference: $bookingReference, customer: $customer) {
      reference
    }
  }
`;
